export default api => {
	const user = api.addResource("user");
	user.addResource("profile");

	const password = user.addResource("password");
	password.addResource("restore");
};
